import styled from 'styled-components';
import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';
import { ImageSectionTemplate } from './ImageSectionTemplate';

export const ImageSectionStyled = styled(ImageSectionTemplate)`
    margin-top: ${rem(20)};
    position: relative;
    padding-bottom: ${rem(30)};

    @media (min-width: ${breakpoints.md}px) {
        ${({ isSummary, isBasket }) =>
            !isSummary &&
            !isBasket &&
            css`
                position: sticky;
                top: ${rem(157)};
            `}
    }

    .switcherWithMarketingRow {
        display: flex;
        justify-content: space-between;
    }

    .react-multiple-carousel__arrow {
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.black};
        border-radius: unset;
        cursor: pointer;
        padding: ${rem(3)};
        z-index: 900;

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.black};

            &::before {
                color: ${({ theme }) => theme.colors.white};
            }
        }

        &::before {
            color: ${({ theme }) => theme.colors.black};
            font-family: revicons-override !important;
        }

        &--right {
            margin-right: -${rem(14)};
        }

        &--left {
            margin-left: -${rem(14)};
        }
    }

    .car-item-wrapper {
        margin-bottom: unset;
    }

    .vehicle {
        padding: ${rem(10)};

        @media (min-width: ${breakpoints.md}px) {
            position: absolute;
            left: 53%;
            top: ${rem(45)};
        }
    }

    .ext,
    .int {
        ${({ isBasket }) =>
            isBasket &&
            css`
                @media (min-width: ${breakpoints.md}px) {
                    width: 50%;
                }
            `}
    }

    .toggle {
        background: ${({ theme }) => theme.colors.grey7};
        width: 90px;
        margin-right: ${rem(10)};
        height: ${rem(40)};
        padding: ${rem(5)};
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: ${rem(20)};

        button {
            &:focus-visible {
                background: ${({ theme }) => theme.colors.white};
                border-radius: 50%;
            }
        }

        .ext,
        .int {
            width: ${rem(35)};
            height: ${rem(30)};
            border-radius: 50%;
            margin: 0 ${rem(2)};
            cursor: pointer;

            &:hover {
                background: ${({ theme }) => theme.colors.white};
            }

            &.active {
                background: ${({ theme }) => theme.colors.white};
            }

            svg {
                width: ${rem(36)};
                height: ${rem(32)};
            }
        }
    }

    .delivery {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        background: ${({ theme }) => theme.colors.grey8};
        padding: ${rem(4)} ${rem(8)};
        border-radius: ${rem(15)};
        margin-top: ${rem(24)};
        display: inline-block;
    }

    .redirectLink {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        cursor: pointer;
        margin-top: ${rem(8)};
        display: block;

        span {
            border-bottom: 1px solid ${({ theme }) => theme.colors.black};
        }
    }

    .dealer {
        padding: ${rem(16)} 0;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.black};
        margin-left: -${rem(4)};

        .label {
            display: flex;
            align-items: center;
            padding-bottom: ${rem(2)};

            .icon-wrapper {
                height: ${rem(24)};
            }

            svg {
                width: ${rem(28)};
                height: ${rem(28)};
                margin-top: -${rem(4)};

                path {
                    fill: ${({ theme }) => theme.colors.black};
                }

                g {
                    path {
                        fill: ${({ theme }) => theme.colors.black};
                    }
                }
            }
        }

        .title {
            text-transform: uppercase;
        }

        .title,
        .address,
        .link {
            padding: 0 0 ${rem(6)} ${rem(28)};
        }

        .link {
            cursor: pointer;
            text-decoration: underline;
            background: none;
            border: none;
        }
    }
`;
